var _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_o { 0% { opacity: 1; } 10% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,1,1); } 35.35% { opacity: 0; } 70% { opacity: 0; animation-timing-function: cubic-bezier(0.915,0,1,1); } 81.9% { opacity: 1; } 100% { opacity: 1; } }\n@keyframes a1_o { 0% { opacity: 1; } 22.3% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,1,1); } 47.65% { opacity: 0; } 78.85% { opacity: 0; animation-timing-function: cubic-bezier(0.915,0,1,1); } 91% { opacity: 1; } 100% { opacity: 1; } }\n@keyframes a2_o { 0% { opacity: 1; } 34.6% { opacity: 1; animation-timing-function: cubic-bezier(0.42,0,1,1); } 60% { opacity: 0; } 87.85% { opacity: 0; animation-timing-function: cubic-bezier(0.915,0,1,1); } 100% { opacity: 1; } }\n    ")), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5,10.5765L6.9,10.5765L6.9,13.9765L3.5,13.9765L3.5,10.5765Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(5.2,12.28) translate(-5.2,-12.2765)",
    style: {
      animation: "2s linear infinite both a0_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3,10.5765L13.7,10.5765L13.7,13.9765L10.3,13.9765L10.3,10.5765Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(12,12.2765) translate(-12,-12.2765)",
    style: {
      animation: "2s linear infinite both a1_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1,10.5765L20.5,10.5765L20.5,13.9765L17.1,13.9765L17.1,10.5765Z",
    fill: "#A1A8B3",
    opacity: 1,
    transform: "translate(18.8,12.2765) translate(-18.8,-12.2765)",
    style: {
      animation: "2s linear infinite both a2_o"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6b5cc912e07881a3217bc2193fd95f7d.svg";
export { ForwardRef as ReactComponent };